/**
 * DEMO strip — rendered only in demo builds (`vite build --mode demo`, which the
 * branch-deploy workflow runs and which loads .env.demo).
 *
 * Kept in normal flow at the top of the shell so it displaces the layout instead
 * of covering the top bar. Also prefixes the tab title, because the demo panel
 * and the real panel look identical side by side.
 *
 * The demo points at the isolated STAGING Firestore: approve, block, delete
 * freely — everything here is seeded fake data (reset any time).
 */
import { useEffect } from 'react';

/** True in branch/preview builds. Production builds set VITE_APP_ENV=production. */
export const IS_DEMO = import.meta.env.VITE_APP_ENV === 'demo';

export function DemoBanner(): JSX.Element | null {
  useEffect(() => {
    if (IS_DEMO && !document.title.startsWith('[DEMO]')) {
      document.title = `[DEMO] ${document.title}`;
    }
  }, []);

  if (!IS_DEMO) return null;

  return (
    <div
      className="flex shrink-0 items-center justify-center gap-2 bg-amber-400 px-4 py-1.5 text-[11px] font-bold uppercase tracking-wide text-amber-950"
      role="status"
    >
      <span aria-hidden>⚠</span>
      Demo build — isolated staging data, nothing here is real
      {import.meta.env.VITE_DEMO_REF ? (
        <span className="rounded bg-amber-950/15 px-1.5 py-0.5 font-mono normal-case tracking-normal">
          {import.meta.env.VITE_DEMO_REF}
        </span>
      ) : null}
    </div>
  );
}
